export default "__VITE_PUBLIC_ASSET__95d66686__"